import { render, staticRenderFns } from "./checkCarton.vue?vue&type=template&id=2b12ec20&scoped=true&"
import script from "./checkCarton.vue?vue&type=script&lang=js&"
export * from "./checkCarton.vue?vue&type=script&lang=js&"
import style0 from "./checkCarton.vue?vue&type=style&index=0&id=2b12ec20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b12ec20",
  null
  
)

export default component.exports